import { Button, Paper, Stack, Typography } from '@mui/material';
import { useGetProductImageQuery, useUploadProductImageMutation } from '../features/products/skuImageSlice';
import Loading from './Loading';
import no_images from '../images/no_images@2x.png';
import DropArea from './DropArea';
import { capitalized } from '../helpers/strings';
import { useCallback, useState } from 'react';
import AlignmentEditor from './AlignmentEditor';
import { useGetSKUImagesQuery } from '../features/model/skuSlice';

const ProductPhotoView = ({product, side="front", skuimages, width=400, height=null, purpose=""}) => {
    const skip_load = (side==="front" && product.front_template === null) || (side==="back" && product.back_template === null);
    const {data: image, error, isLoading } = useGetProductImageQuery({sku_id: product.id, side: side, width: width}, {
        skip: skip_load})

    const [uploadProductImage, {isLoadingUpdate: isUploading }] = useUploadProductImageMutation();
    const [aligning, setAligning] = useState(false);
    
    const uploadImage = useCallback((files) => {
        let file = files[0];
        const reader = new FileReader()
        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = () => {
          const binaryStr = reader.result
          uploadProductImage({sku_id: product.id, purpose: purpose, data: binaryStr})
        }
        reader.readAsArrayBuffer(file)
    });

    if (isLoading) {
        return <Loading />;
    }
    if (error) {
        return <div>Error: {error}</div>
    }

    function startAligning() {
        setAligning(true);
    }

    let imgelement = [];
    let actions = [];
    var this_skuimage = null;
    if(skuimages) {
        skuimages.objects.forEach((skuimage) => {
            if((skuimage.purpose === "preview" && side === "front") || (skuimage.purpose === "preview_back" && side === "back")) {
                this_skuimage = skuimage
            }
        })
    }
    if(image) {
        if(aligning) {
            /*if (skuimagesIsLoading)
                imgelement.push(<Loading key="loading" />)
            else
                imgelement.push(<AlignmentEditor product={product} side={side} skuimage={this_skuimage} key="alignment" />)
            */
        } else {
            if (height === null) {
                imgelement.push(<img key="image" src={image} alt="Preview" style={{borderRadius: 4}} />)
            } else {
                imgelement.push(<img key="image" src={image} alt="Preview" style={{borderRadius: 4, width: width, height: height, objectFit: "cover"}} />)
            }
            //actions.push(<Button key="align" variant="outlined" onClick={startAligning}>Align</Button>)
        }
    }

    return <>
        <Paper style={{padding: 8}} elevation={4}>
        <Stack spacing={1}>
            <Stack direction="row" justifyContent="space-between" spacing={2}>
                <Typography variant="h6" marginBottom={0}>{capitalized(side)}</Typography>
                <Stack direction="row" spacing={1}>
                {actions}
                <DropArea fileHandler={uploadImage}/>
                </Stack>
            </Stack>
            {imgelement}
        </Stack>
        </Paper>
    </>;
}

export default ProductPhotoView;